module.exports = __webpack_public_path__ + "static/logo-white-cb35f824697190dd29a34a2c82253090.svg";